var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.FormControlPlainText, { staticClass: "small" }, [
        _vm._v("\n        Email sent:\n        "),
        _setup.lastSent
          ? _c("span", [_vm._v(_vm._s(_setup.dateStr))])
          : _c("em", [_vm._v("never")]),
      ]),
      _vm._v(" "),
      _c(
        _setup.Button,
        {
          staticClass: "border",
          attrs: { disabled: _setup.isDisabled },
          nativeOn: {
            click: function ($event) {
              return _setup.resendEmail.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n        Send receipt\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }